import { render } from "./ProductApplicationPage.vue?vue&type=template&id=2cf8c783&scoped=true"
import script from "./ProductApplicationPage.vue?vue&type=script&lang=js"
export * from "./ProductApplicationPage.vue?vue&type=script&lang=js"

import "./ProductApplicationPage.vue?vue&type=style&index=0&id=2cf8c783&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf8c783"]])

export default __exports__